module.exports = __webpack_public_path__ + "static/dde-logo-c85c8ed89e50e2f774ab2172549ac79c.svg";